import type { SVGProps } from "react";

export function IconVideoPip(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      aria-hidden="true"
      fill="none"
      height="16"
      viewBox="0 0 20 16"
      width="20"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>Video picture in picture</title>
      <rect
        height="14.5"
        rx="1.5"
        stroke="white"
        strokeWidth="1.5"
        width="18.5"
        x="0.75"
        y="0.75"
      />
      <rect fill="white" height="6" rx="1" width="8" x="10" y="7" />
    </svg>
  );
}
